import { SVGProps } from 'react';

const Minimize2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14 10 7-7m-7 1v6h6M3 21l7-7m0 6v-6H4"
    />
  </svg>
);
export default Minimize2;
